// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--2iijK","description":"about-module--description--6Y2oO","icons":"about-module--icons--1bRfn"};